module.exports = __webpack_public_path__ + "static/ICONS_CTA-315297957540c925c0beea2a80b04256.png";